module.exports = __webpack_public_path__ + "img/media-donews@2x.d9db6dc8.png";